export default __webpack_public_path__ + "static/media/telegram.276e4f92.webp";